import { graphql } from '@/gql';
import { mutationExecute } from '@/Utils/graphqlAPI';

export const payForAnyUnpaidGourmetOrders = async (phoneNumber: string) => {
  const response = await mutationExecute({
    variables: {
      phoneNumber,
    },
    mutation: graphql(`
      mutation PayForAnyUnpaidGourmetOrders($phoneNumber: String!) {
        payForAnyUnpaidGourmetOrders(phoneNumber: $phoneNumber)
      }
    `),
  });

  return response.data?.payForAnyUnpaidGourmetOrders ?? '';
};
